
import { defineComponent } from "vue";
import UserRegistrationComponent from "@/components/users/UserRegistration.component.vue";
import UserListComponent from "@/components/users/UserList.component.vue";

import { User } from "@/types/user.type";
import { ElMessage } from "element-plus";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import { AppType } from "@/types/app.type";
import securityService from "@/service/security.service";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    UserRegistrationComponent,
    UserListComponent,
    PageButtonsComponent,
  },
  setup() {
    const isAppAdmin = securityService.isApp(AppType.ADMIN);
    const appIsAdminAndRoleIsAdmin = isAppAdmin && securityService.canAccessToApp(AppType.ADMIN);
    const listCanWrite = appIsAdminAndRoleIsAdmin;
    const canCreate = appIsAdminAndRoleIsAdmin;

    return {
      listCanWrite,
      canCreate,
    };
  },
  data() {
    return {
      showUserForm: false,
      userForm: undefined as undefined | User,
      active: 0,
    };
  },
  async mounted() {
    const store = useStore<RootState>();
    const route = useRoute();
    const router = useRouter();

    if (store.state.auth.user?.id) {
      try {
        let userRoutes = await getAvailableRoutes(store.state.auth.user.id);
        if (userRoutes.length > 0 && !userRoutes.includes(route.path)) {
          router.go(-1);
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    }
  },
  methods: {
    openUserFormDialog(item: User | undefined = undefined) {
      this.userForm = item;
      this.showUserForm = true;
    },
    /**
     * close user formDialog
     */
    closeUserFormDialog() {
      this.userForm = undefined;
      this.showUserForm = false;
    },

    /**
     * save user
     */
    saveUser() {
      // - call userForm save method
      //TODO Guardar un usuario
      (this.$refs["userForm"] as InstanceType<typeof UserRegistrationComponent>)
        .doSave()
        ?.then(() => {
          this.closeUserFormDialog();
          (this.$refs["userList"] as InstanceType<typeof UserListComponent>).refreshUser();
          this.active = 0;
          ElMessage.success(this.$t("success.user"));
        })
        .catch(() => void 0);
    },
    next() {
      if (this.active <= 2) {
        this.active++;
      }
    },
    previous() {
      this.active--;
    },
  },
});
